import parser from 'html-react-parser';
import React, { useEffect } from 'react';
import { MdLocationOn } from 'react-icons/md';
import { BsTelephoneFill } from 'react-icons/bs';
import { FaGlobe } from 'react-icons/fa';
import { Link } from 'gatsby';

const BlogPage = ({ data }) => {
	console.log(data);
	
	useEffect(() => {
		const element = [...document.getElementsByClassName('para-list')];
		element.forEach((element) => {
			if (
				element.childNodes[0].localName === 'p' ||
				element.childNodes[0].localName === 'h4'
			) {
				element.classList.remove('list-disc');
				element.classList.add('-ml-8');
			}
		});
	}, []);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [data]);

	return (
		<div className='w-full md:w-8/12 bg-[#F8F8FA] rounded-2xl p-4 md:p-8'>
			<div className='min-h-[40rem] rounded-lg w-full md:mx-auto'>
				<h1 className='text-xl md:text-2xl text-black font-bold mb-4'>
					{data.title}
				</h1>
				<img
					src={data.featuredImage}
					alt=''
					className='rounded-2xl'
				/>

				<p className='text-black mt-4 text-xl md:text-2xl font-bold hidden'>
					{data.title.split(' | ')[0]}
				</p>
				<div className='ml-8 md:text-lg'>
					{data.content.map((item, index) => {
						return (
							<div className='' key={index}>
								{item.imageUrl && (
									<img
										src={item.imageUrl}
										alt='para'
										className='my-8 mx-auto rounded-lg -ml-6'
									/>
								)}
								{item.title && (
									<h2 className='text-[#071721] font-bold -ml-8 mt-12'>
										{parser(item.title)}
									</h2>
								)}
								{item.shortInfo && (
									<div
										className={`flex flex-col md:items-start md:gap-x-4 mt-4 md:mt-8 -ml-8 ${
											item.shortInfo
												.reverse
												? 'md:flex-row-reverse'
												: 'md:flex-row'
										}`}
									>
										{/* Image Section - Always on top in mobile, adjusts order on desktop based on 'reverse' */}
										<div className='w-full flex justify-center md:w-1/2 md:mt-0'>
											<img
												className='h-52 w-full object-cover rounded-lg'
												src={
													item
														.shortInfo
														.imageUrl
												}
												alt='illustration'
											/>
										</div>

										{/* Content Section */}
										<div className='w-full md:w-1/2'>
											<div>
												{Object.entries(
													item.shortInfo,
												).map(
													([
														key,
														value,
													]) =>
														key !==
															'imageUrl' &&
														key !==
															'reverse' &&
														key !==
															'GoogleMap' &&
														key !==
															'CityGuide' ? (
															<p
																key={
																	key
																}
																className={`text-[#071721] font-[500] md:ml-0 ${
																	key ===
																	'name'
																		? 'mb-4 text-lg text-[#626262] font-[700]'
																		: 'm-0'
																}`}
															>
																{key ===
																'name'
																	? parser(
																			value,
																	  )
																	: key !==
																			'imageUrl' &&
																	  key !==
																			'reverse' && (
																			<span>
																				<span className='flex mt-2'>
																					<span>
																						{key ===
																							'Address' && (
																							<MdLocationOn className='w-7 h-7 p-1 rounded-full bg-[#F1A73C] text-white' />
																						)}
																						{key ===
																							'Phone' && (
																							<BsTelephoneFill className='w-7 h-7 p-1 rounded-full bg-[#F1A73C] text-white' />
																						)}
																						{key ===
																							'Website' && (
																							<FaGlobe className='w-7 h-7 p-1 rounded-full bg-[#F1A73C] text-white' />
																						)}
																					</span>
																					{key !==
																						'GoogleMap' &&
																						key !==
																							'CityGuide' && (
																							<span
																								className={`ml-2 text-[#626262] ${
																									key ===
																									'Website'
																										? 'underline'
																										: ''
																								}`}
																							>
																								{parser(
																									value,
																								)}
																							</span>
																						)}
																				</span>
																				<span className='flex'>
																					{(key ===
																						'GoogleMap' ||
																						key ===
																							'CityGuide') && (
																						<Link
																							key={
																								key
																							}
																							className='px-2 py-1 rounded-lg text-sm md:text-lg border border-[#6CB132]'
																							href='https://www.google.com'
																						>
																							{key ===
																							'GoogleMap'
																								? 'Google Map'
																								: 'City Guide'}
																						</Link>
																					)}
																				</span>
																			</span>
																	  )}
															</p>
														) : null,
												)}
											</div>
											<div className='w-full flex mt-4 gap-4'>
												{Object.entries(
													item.shortInfo,
												).map(
													([
														key,
														value,
													]) =>
														key ===
															'GoogleMap' ||
														key ===
															'CityGuide' ? (
															<span className='flex'>
																{(key ===
																	'GoogleMap' ||
																	key ===
																		'CityGuide') && (
																	<Link
																		key={
																			key
																		}
																		className='px-2 py-1 rounded-lg text-sm md:text-lg border border-[#6CB132] text-[#6CB132]'
																		href='https://www.google.com'
																	>
																		{key ===
																		'GoogleMap'
																			? 'Google Map'
																			: 'City Guide'}
																	</Link>
																)}
															</span>
														) : null,
												)}
											</div>
										</div>
									</div>
								)}

								{item.para && (
									<ul className='my-4'>
										{item.para.map(
											(
												text,
												index,
											) => (
												<li
													className={`para-list text-[#626262] mb-4 list-disc [&_a]:text-blue-500 leading-relaxed ${
														text.startsWith(
															'<p>About',
														)
															? 'font-bold'
															: ''
													}`}
													key={
														index
													}
												>
													{parser(
														text,
													)}
												</li>
											),
										)}
									</ul>
								)}
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default BlogPage;
